<template>
    <div class="editor-property">
        <div class="editor-property-title">
            <h3>{{ title }}</h3>
        </div>
        <div class="editor-property-body">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-property",
    components: {

    },
    props: {
        title: {
            type: String,
            default: "Panel",
            required: true,
        },
    },
    data() {
        return {

        };
    },

    mounted() {
        let vm = this;

    },
    methods: {

    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.editor-property {
    margin-bottom: 3px;
    display: flex;
    align-items: center;
    justify-content: stretch;


    .editor-property-title {
        width: max-content;
        margin-right: 10px;

        h3 {
            margin: 0;
            font-size: 12px;
        }
    }

    .editor-property-body {
        padding: 0px 5px;
    }

    &.veritical {
        flex-direction: column;
        margin-bottom: 10px;

        .editor-property-title {
            width: 100%;
            margin-bottom: 5px;
            margin-right: 0px;
        }

        .editor-property-body {
            width: 100%;
            padding: 0px 0px;
        }
    }
}
</style>